export enum EmailTemplateNotificationTypesEnum {
    Email = 1,
    SMS,
    WhatsApp,
    PushNotification,
    TeamsChatMessage
}

export const EmailTemplateNotificationTypes = [
    {
        id: EmailTemplateNotificationTypesEnum.Email,
        name: 'Email'
    },
    {
        id: EmailTemplateNotificationTypesEnum.SMS,
        name: 'SMS'
    },
    {
        id: EmailTemplateNotificationTypesEnum.WhatsApp,
        name: 'WhatsApp'
    },
    {
        id: EmailTemplateNotificationTypesEnum.PushNotification,
        name: 'Push Notification'
    },
    {
        id: EmailTemplateNotificationTypesEnum.TeamsChatMessage,
        name: 'Teams Chat Message'
    }
];
